"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AFFORDABLE_ANNUAL_INCOME_FIELD = exports.AFFORDABLE_MONTHLY_INCOME_FIELD = exports.AFFORDABLE_SEMI_MONTHLY_INCOME_FIELD = exports.AFFORDABLE_BI_WEEKLY_INCOME_FIELD = exports.AFFORDABLE_WEEKLY_INCOME_FIELD = exports.AFFORDABLE_HOURLY_INCOME_FIELD = exports.INCOME_FIELD_QUESTION = exports.getNonFederalWagesFields = exports.getRentVoucherFields = exports.getInterestPaymentsFields = exports.getPublicAssistanceFields = exports.getSeverancePackageFields = exports.getVeteransBenefitsFields = exports.getGiftPaymentsFields = exports.getSocialSecurityFields = exports.getRetirementPlanPaymentsFields = exports.getVaBenefitsFields = exports.getWorkersCompensationFields = exports.getDisabilityFields = exports.getDhsFields = exports.getCommissionsFields = exports.getCashContributionsFields = exports.getChildSupportOrAlimonyOtherFields = exports.getStudentFinancialAssistanceOtherFields = exports.getStudentFinancialAssistanceParentalAssistanceFields = exports.getStudentFinancialAssistanceLoansFields = exports.getChildSupportOrAlimonyIndividualFields = exports.getStudentFinancialAssistanceGrantsFields = exports.getChildSupportOrAlimonyCourtOfLawFields = exports.getStudentFinancialAssistanceScholarshipsFields = exports.getChildSupportOrAlimonyEnforcementAgencyFields = exports.getStudentFinancialAssistanceWorkStudyFields = exports.getAnnuitiesFields = exports.getAidToFamiliesWithDependantChildrenFields = exports.getBusinessFields = exports.getFederalWageFields = exports.getMilitaryPayFields = exports.getUnemploymentFields = exports.getTemporaryAssistanceForNeedyFamiliesFields = exports.getSupplementalSecurityIncomeFields = exports.getPensionsFields = exports.getOtherNonWageSourceFields = exports.getIndianTrustFields = exports.getGeneralAssistanceFields = exports.getFinancialAidFields = exports.getChildSupportFields = exports.getOtherIncomeFields = exports.getSelfEmployerFields = exports.getPreviousEmployerFields = exports.getCurrentEmployerFields = void 0;
exports.getConventionalIncomeFields = exports.getAffordableIncomeFields = void 0;
exports.getFieldStructure = getFieldStructure;
var entities_1 = require("@common/entities");
var AFFORDABLE_INCOME_FIELD_1 = require("./AFFORDABLE_INCOME_FIELD");
Object.defineProperty(exports, "getAffordableIncomeFields", { enumerable: true, get: function () { return AFFORDABLE_INCOME_FIELD_1.getAffordableIncomeFields; } });
Object.defineProperty(exports, "AFFORDABLE_HOURLY_INCOME_FIELD", { enumerable: true, get: function () { return AFFORDABLE_INCOME_FIELD_1.AFFORDABLE_HOURLY_INCOME_FIELD; } });
Object.defineProperty(exports, "AFFORDABLE_WEEKLY_INCOME_FIELD", { enumerable: true, get: function () { return AFFORDABLE_INCOME_FIELD_1.AFFORDABLE_WEEKLY_INCOME_FIELD; } });
Object.defineProperty(exports, "AFFORDABLE_BI_WEEKLY_INCOME_FIELD", { enumerable: true, get: function () { return AFFORDABLE_INCOME_FIELD_1.AFFORDABLE_BI_WEEKLY_INCOME_FIELD; } });
Object.defineProperty(exports, "AFFORDABLE_SEMI_MONTHLY_INCOME_FIELD", { enumerable: true, get: function () { return AFFORDABLE_INCOME_FIELD_1.AFFORDABLE_SEMI_MONTHLY_INCOME_FIELD; } });
Object.defineProperty(exports, "AFFORDABLE_MONTHLY_INCOME_FIELD", { enumerable: true, get: function () { return AFFORDABLE_INCOME_FIELD_1.AFFORDABLE_MONTHLY_INCOME_FIELD; } });
Object.defineProperty(exports, "AFFORDABLE_ANNUAL_INCOME_FIELD", { enumerable: true, get: function () { return AFFORDABLE_INCOME_FIELD_1.AFFORDABLE_ANNUAL_INCOME_FIELD; } });
var CONVENTIONAL_INCOME_FIELDS_1 = require("./CONVENTIONAL_INCOME_FIELDS");
Object.defineProperty(exports, "getConventionalIncomeFields", { enumerable: true, get: function () { return CONVENTIONAL_INCOME_FIELDS_1.getConventionalIncomeFields; } });
var constants_1 = require("../../constants");
var getFields = function (incomeType, isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    if (isAffordable) {
        return (0, AFFORDABLE_INCOME_FIELD_1.getAffordableIncomeFields)(incomeType);
    }
    return (0, CONVENTIONAL_INCOME_FIELDS_1.getConventionalIncomeFields)(incomeType);
};
function getFieldStructure(name, label, incomeType, isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return {
        name: name,
        label: label,
        customType: incomeType,
        elementType: entities_1.SectionElementType.Block,
        paymentInterval: entities_1.Interval.Monthly,
        documentUpload: {
            maxFilesAllowed: '2',
            maxFilesRequired: '0',
            verifyDocumentUpload: true,
        },
        fields: getFields(incomeType, isAffordable),
    };
}
var getCurrentEmployerFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('current_employer', 'Current Employer', entities_1.IncomeTypes.CurrentEmployer, isAffordable);
};
exports.getCurrentEmployerFields = getCurrentEmployerFields;
var getPreviousEmployerFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('previous_employer', 'Previous Employer', entities_1.IncomeTypes.PreviousEmployer, isAffordable);
};
exports.getPreviousEmployerFields = getPreviousEmployerFields;
var getSelfEmployerFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('self_employer', 'Self Employer', entities_1.IncomeTypes.SelfEmployer, isAffordable);
};
exports.getSelfEmployerFields = getSelfEmployerFields;
var getOtherIncomeFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('other_income', 'Other Income', entities_1.IncomeTypes.OtherIncome, isAffordable);
};
exports.getOtherIncomeFields = getOtherIncomeFields;
var getChildSupportFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('child_support', 'Child Support', entities_1.IncomeTypes.ChildSupport, isAffordable);
};
exports.getChildSupportFields = getChildSupportFields;
var getFinancialAidFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('financial_aid', 'Financial Aid', entities_1.IncomeTypes.FinancialAid, isAffordable);
};
exports.getFinancialAidFields = getFinancialAidFields;
var getGeneralAssistanceFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('general_assistance', 'General Assistance', entities_1.IncomeTypes.GeneralAssistance, isAffordable);
};
exports.getGeneralAssistanceFields = getGeneralAssistanceFields;
var getIndianTrustFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('indian_trust', 'Indian Trust', entities_1.IncomeTypes.IndianTrust, isAffordable);
};
exports.getIndianTrustFields = getIndianTrustFields;
var getOtherNonWageSourceFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('other_non_wage_source', 'Other Non-Wage Source', entities_1.IncomeTypes.OtherNonWageSource, isAffordable);
};
exports.getOtherNonWageSourceFields = getOtherNonWageSourceFields;
var getPensionsFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('pensions', 'Pensions', entities_1.IncomeTypes.Pensions, isAffordable);
};
exports.getPensionsFields = getPensionsFields;
var getSupplementalSecurityIncomeFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('supplemental_security_income', 'Supplemental Security Income', entities_1.IncomeTypes.SupplementalSecurityIncome, isAffordable);
};
exports.getSupplementalSecurityIncomeFields = getSupplementalSecurityIncomeFields;
var getTemporaryAssistanceForNeedyFamiliesFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('temporary_assistance_for_needy_families', 'Temporary Assistance for Needy Families', entities_1.IncomeTypes.TemporaryAssistanceForNeedyFamilies, isAffordable);
};
exports.getTemporaryAssistanceForNeedyFamiliesFields = getTemporaryAssistanceForNeedyFamiliesFields;
var getUnemploymentFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('unemployment', 'Unemployment', entities_1.IncomeTypes.Unemployment, isAffordable);
};
exports.getUnemploymentFields = getUnemploymentFields;
var getMilitaryPayFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('military_pay', 'Military Pay', entities_1.IncomeTypes.MilitaryPay, isAffordable);
};
exports.getMilitaryPayFields = getMilitaryPayFields;
var getFederalWageFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('federal_wage', 'Federal Wage', entities_1.IncomeTypes.FederalWage, isAffordable);
};
exports.getFederalWageFields = getFederalWageFields;
var getBusinessFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('business', 'Business', entities_1.IncomeTypes.BusinessOrRentalIncome, isAffordable);
};
exports.getBusinessFields = getBusinessFields;
var getAidToFamiliesWithDependantChildrenFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('aid_to_families_with_dependant_children', 'Aid to Families with Dependant Children', entities_1.IncomeTypes.AidToFamiliesWithDependantChildren, isAffordable);
};
exports.getAidToFamiliesWithDependantChildrenFields = getAidToFamiliesWithDependantChildrenFields;
var getAnnuitiesFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('annuities', 'Annuities', entities_1.IncomeTypes.Annuities, isAffordable);
};
exports.getAnnuitiesFields = getAnnuitiesFields;
var getStudentFinancialAssistanceWorkStudyFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('student_financial_assistance_work_study', 'Student Financial Assistance Work Study', entities_1.IncomeTypes.StudentFinancialAssistanceWorkStudy, isAffordable);
};
exports.getStudentFinancialAssistanceWorkStudyFields = getStudentFinancialAssistanceWorkStudyFields;
var getChildSupportOrAlimonyEnforcementAgencyFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('child_support_or_alimony_enforcement_agency', 'Child Support Or Alimony Enforcement Agency', entities_1.IncomeTypes.ChildSupportOrAlimonyEnforcementAgency, isAffordable);
};
exports.getChildSupportOrAlimonyEnforcementAgencyFields = getChildSupportOrAlimonyEnforcementAgencyFields;
var getStudentFinancialAssistanceScholarshipsFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('student_financial_assistance_scholarships', 'Student Financial Assistance Scholarships', entities_1.IncomeTypes.StudentFinancialAssistanceScholarships, isAffordable);
};
exports.getStudentFinancialAssistanceScholarshipsFields = getStudentFinancialAssistanceScholarshipsFields;
var getChildSupportOrAlimonyCourtOfLawFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('child_support_or_alimony_court_of_law', 'Child Support Or Alimony Court Of Law', entities_1.IncomeTypes.ChildSupportOrAlimonyCourtOfLaw, isAffordable);
};
exports.getChildSupportOrAlimonyCourtOfLawFields = getChildSupportOrAlimonyCourtOfLawFields;
var getStudentFinancialAssistanceGrantsFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('student_financial_assistance_grants', 'Student Financial Assistance Grants', entities_1.IncomeTypes.StudentFinancialAssistanceGrants, isAffordable);
};
exports.getStudentFinancialAssistanceGrantsFields = getStudentFinancialAssistanceGrantsFields;
var getChildSupportOrAlimonyIndividualFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('child_support_or_alimony_individual', 'Child Support Or Alimony Individual', entities_1.IncomeTypes.ChildSupportOrAlimonyIndividual, isAffordable);
};
exports.getChildSupportOrAlimonyIndividualFields = getChildSupportOrAlimonyIndividualFields;
var getStudentFinancialAssistanceLoansFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('student_financial_assistance_loans', 'Student Financial Assistance Loans', entities_1.IncomeTypes.StudentFinancialAssistanceLoans, isAffordable);
};
exports.getStudentFinancialAssistanceLoansFields = getStudentFinancialAssistanceLoansFields;
var getStudentFinancialAssistanceParentalAssistanceFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('student_financial_assistance_parental_assistance', 'Student Financial Assistance Parental Assistance', entities_1.IncomeTypes.StudentFinancialAssistanceParentalAssistance, isAffordable);
};
exports.getStudentFinancialAssistanceParentalAssistanceFields = getStudentFinancialAssistanceParentalAssistanceFields;
var getStudentFinancialAssistanceOtherFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('student_financial_assistance_other', 'Student Financial Assistance Other', entities_1.IncomeTypes.StudentFinancialAssistanceOther, isAffordable);
};
exports.getStudentFinancialAssistanceOtherFields = getStudentFinancialAssistanceOtherFields;
var getChildSupportOrAlimonyOtherFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('child_support_or_alimony_other', 'Child Support Or Alimony Other', entities_1.IncomeTypes.ChildSupportOrAlimonyOther, isAffordable);
};
exports.getChildSupportOrAlimonyOtherFields = getChildSupportOrAlimonyOtherFields;
var getCashContributionsFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('cash_contributions', 'Cash Contributions', entities_1.IncomeTypes.CashContributions, isAffordable);
};
exports.getCashContributionsFields = getCashContributionsFields;
var getCommissionsFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('commissions', 'Commissions', entities_1.IncomeTypes.Commissions, isAffordable);
};
exports.getCommissionsFields = getCommissionsFields;
var getDhsFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('dhs', 'DHS ($42.00)', entities_1.IncomeTypes.Dhs, isAffordable);
};
exports.getDhsFields = getDhsFields;
var getDisabilityFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('disability', 'Disability', entities_1.IncomeTypes.Disability, isAffordable);
};
exports.getDisabilityFields = getDisabilityFields;
var getWorkersCompensationFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('workers_compensation', 'Workers Compensation', entities_1.IncomeTypes.WorkersCompensation, isAffordable);
};
exports.getWorkersCompensationFields = getWorkersCompensationFields;
var getVaBenefitsFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('va_benefits', 'VA Benefits', entities_1.IncomeTypes.VaBenefits, isAffordable);
};
exports.getVaBenefitsFields = getVaBenefitsFields;
var getRetirementPlanPaymentsFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('retirement_plan_payments', 'Retirement Plan Payments', entities_1.IncomeTypes.RetirementPlanPayments, isAffordable);
};
exports.getRetirementPlanPaymentsFields = getRetirementPlanPaymentsFields;
var getSocialSecurityFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('social_security', 'Social Security', entities_1.IncomeTypes.SocialSecurity, isAffordable);
};
exports.getSocialSecurityFields = getSocialSecurityFields;
var getGiftPaymentsFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('gift_payments', 'Gift Payments', entities_1.IncomeTypes.GiftPayments, isAffordable);
};
exports.getGiftPaymentsFields = getGiftPaymentsFields;
var getVeteransBenefitsFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('veterans_benefits', 'Veterans Benefits', entities_1.IncomeTypes.VeteransBenefits, isAffordable);
};
exports.getVeteransBenefitsFields = getVeteransBenefitsFields;
var getSeverancePackageFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('severance_package', 'Severance Package', entities_1.IncomeTypes.SeverancePackage, isAffordable);
};
exports.getSeverancePackageFields = getSeverancePackageFields;
var getPublicAssistanceFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('public_assistance', 'Public Assistance', entities_1.IncomeTypes.PublicAssistance, isAffordable);
};
exports.getPublicAssistanceFields = getPublicAssistanceFields;
var getInterestPaymentsFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('interest_payments', 'Interest Payments', entities_1.IncomeTypes.InterestPayments, isAffordable);
};
exports.getInterestPaymentsFields = getInterestPaymentsFields;
var getRentVoucherFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('rent_voucher', 'Rent Voucher', entities_1.IncomeTypes.RentVoucher, isAffordable);
};
exports.getRentVoucherFields = getRentVoucherFields;
var getNonFederalWagesFields = function (isAffordable) {
    if (isAffordable === void 0) { isAffordable = false; }
    return getFieldStructure('non_federal_wages', 'Non Federal Wages', entities_1.IncomeTypes.NonFederalWages, isAffordable);
};
exports.getNonFederalWagesFields = getNonFederalWagesFields;
exports.INCOME_FIELD_QUESTION = [
    {
        customType: entities_1.FieldType.Radio,
        enabled: true,
        label: 'Do you have an income?',
        name: 'income_question',
        required: true,
        sequence: 1,
        type: entities_1.FieldType.Radio,
        options: constants_1.YES_NO_OPTIONS,
    },
];
